const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/users/$userId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Badge } from "@/components/ui/badge";
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/users/$userId")({
  beforeLoad: args => requirePermission(Permissions.AdminUsers.ViewAll, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});